import React, { createContext, useContext, useEffect, useState } from 'react';
import { api } from '../lib/api';
import { applyCountry, domainCountry, getStoredCountry, phoneCountry, storeCountry } from '../lib/country';

const CountryContext = createContext({ country: 'ch', countries: [], multi: false, setCountry: () => {} });

export function CountryProvider({ children }) {
  const [state, setState] = useState({ country: 'ch', countries: [], multi: false, suggested: null });

  useEffect(() => {
    api.getCountries().then(d => {
      const countries = d.countries || [];
      const valid = (c) => c && countries.some(x => x.code === c);
      const fromDomain = domainCountry(countries);
      const stored = getStoredCountry();
      const code = [fromDomain, stored, d.current].find(valid) || countries[0]?.code || 'ch';
      applyCountry(countries.find(c => c.code === code));
      // Solo app / dominio neutro, prima volta, con più paesi: chiediamo conferma.
      const suggested = d.multi && !fromDomain && !valid(stored) ? (phoneCountry(countries) || code) : null;
      setState({ country: code, countries, multi: !!d.multi, suggested });
    }).catch(() => {});
  }, []);

  const setCountry = (code) => {
    const cfg = state.countries.find(c => c.code === code);
    if (!cfg) return;
    storeCountry(code);
    const onDomain = domainCountry(state.countries);
    if (onDomain && onDomain !== code && cfg.domains[0]) {
      window.location.href = `https://${cfg.domains[0]}${window.location.pathname}`;
      return;
    }
    if (code === state.country) { setState(s => ({ ...s, suggested: null })); return; }
    window.location.reload();
  };

  return (
    <CountryContext.Provider value={{ ...state, setCountry }}>
      {children}
    </CountryContext.Provider>
  );
}

export const useCountry = () => useContext(CountryContext);
